<script setup lang="ts">

import { ref, watch } from "vue";
import { logger } from "@pkg/logger";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    default: 'QR Code',
  }
});

const img = ref("");

const emit = defineEmits(['qrGenerated']);

const generateQR = async (url) => {
  try {
    const { default: QRCode } = await import('qrcode');

    img.value = await QRCode.toDataURL(url);
    !!img.value && emit("qrGenerated", true);
  } catch (err) {
    logger.error("Error generating QR:", err);
  }
};

watch(() => props.url, (newUrl) => {
  generateQR(newUrl);
}, { immediate: true });

</script>

<template>
  <img :src="img" :alt="props.alt" v-if="img" />
</template>
